$(document).on('turbolinks:load', () => {
    const $modal = $('#activityPointsModal');
    const $menuApCount = $('#ap_count');

    isSafariBrowser = async () => {
        const $activityPointsPartial = $('[id*="workplace_activity_points"]');
        if (!$activityPointsPartial) return;

        if (/^Apple/.test(navigator.vendor) &&
            /Safari/.test(navigator.userAgent) &&
            !/CriOS|Chrome|FxiOS|EdgiOS|OPiOS/.test(navigator.userAgent)) {
            $activityPointsPartial.addClass('is_safari');
        } else {
            $activityPointsPartial.removeClass('is_safari');
        }
    };

    const parseHtmlToDocument = (htmlString) => {
        const parser = new DOMParser();
        return parser.parseFromString(String(htmlString || ''), 'text/html');
    }

    const extractContentFragment = (doc, targetEl) => {
        if (targetEl && targetEl.id) {
            const sameId = doc.getElementById(targetEl.id);
            if (sameId) return sameId;
        }

        const body = doc.body;
        if (!body) return null;

        if (body.children && body.children.length === 1) return body.children[0];

        return body;
    }

    const sanitizeBodyInPlace = (bodyEl) => {
        if (!bodyEl) return;
        bodyEl.querySelectorAll('style, iframe, object, embed, link[rel="import"], meta').forEach(n => n.remove());

        bodyEl.querySelectorAll('*').forEach((el) => {
            [...el.attributes].forEach((attr) => {
                const name = attr.name.toLowerCase();
                const value = (attr.value || '').trim().toLowerCase();

                if (name.startsWith('on')) el.removeAttribute(attr.name);
                if ((name === 'href' || name === 'src') && value.startsWith('javascript:')) el.removeAttribute(attr.name);

                if (name === 'srcdoc' || name === 'formaction') el.removeAttribute(attr.name);
            });
        });
    }

    const setSafeHtml = async (targetEl, unsafeHtmlString) => {
        const doc = parseHtmlToDocument(unsafeHtmlString);

        const container = extractContentFragment(doc, targetEl);
        if (!container) {
            targetEl.replaceChildren();
            return;
        }

        sanitizeBodyInPlace(container);

        const frag = document.createDocumentFragment();
        while (container.firstChild) frag.appendChild(container.firstChild);

        targetEl.replaceChildren(frag);
    }

    const setAmountPlaceholder = (amount, context = document) => {
        const el = (context instanceof HTMLElement ? context : document)
            .querySelector('#activityPointsModal .amount-placeholder');

        if (!el) return;

        el.replaceChildren();

        const icon = document.createElement('i');
        icon.className = 'bubble-icon me-2 main-bubble';

        const span = document.createElement('span');
        span.className = 'rewards-amount-value ap-rewards';
        span.textContent = String(amount || 0);

        el.append(icon, span);
    };

    const buildVariantBadgeNode = ({ levelClass, icon }) => {
        const badge = document.createElement('div');
        badge.className = `badge size-md ${levelClass}`;

        const i = document.createElement('i');
        i.className = `badge-ico ${levelClass} ico-${icon}`;

        badge.appendChild(i);

        return badge;
    };

    countdownNextDailyLoginMission = async () => {
        const countdownEl = document.querySelector('#daily-mission-countdown .claimable-counter');
        const missionCountdownCard = document.getElementById('daily-mission-countdown');
        if (!missionCountdownCard || !countdownEl) return;

        let secondsRemaining = parseInt(missionCountdownCard.dataset.secondsRemaining || '0', 10);
        if (isNaN(secondsRemaining) || secondsRemaining <= 0) return;

        const formatTime = (seconds) => {
            const h = String(Math.floor(seconds / 3600)).padStart(2, '0');
            const m = String(Math.floor((seconds % 3600) / 60)).padStart(2, '0');
            const s = String(seconds % 60).padStart(2, '0');
            return `${h}:${m}:${s}`;
        };

        countdownEl.textContent = formatTime(secondsRemaining);

        const interval = setInterval(() => {
            secondsRemaining--;
            if (secondsRemaining <= 0) {
                clearInterval(interval);
                countdownEl.textContent = '00:00:00';
                // Optionally reload the section or show a button
            } else {
                countdownEl.textContent = formatTime(secondsRemaining);
            }
        }, 1000);
    };

    showLeaderboardNameModal = async () => {
        const LeaderModalEl = document.getElementById('activityPointsLeaderboard');
        const leaderboardModal = bootstrap.Modal.getInstance(LeaderModalEl);
        if (!LeaderModalEl) return;

        leaderboardModal.show();
    };

    updateRewardsCountBadge = async () => {
        $.ajax({
            url: '/en/workplace/activity_points/daily_login_check_and_rewards_count',
            method: 'GET',
            success: function (data) {
                const rewardsCount = data.rewards_count;
                if (rewardsCount > 0) {
                    $menuApCount.removeClass('d-none');
                    $menuApCount.find('small').text(rewardsCount);
                } else {
                    $menuApCount.addClass('d-none');
                    $menuApCount.find('small').text('');
                }
            }
        });
        countdownNextDailyLoginMission();
    };

    apTotalCounter = (amount = null) => {
        const counters = document.querySelectorAll(".ap_coins_value");
        counters.forEach((counter) => {
            counter.innerText = counter.getAttribute("data-text") || "0";
            const timeoutVal = counter.innerText > 0 ? 10 : 1;
            const updateCounter = () => {
                const target = amount || +counter.getAttribute("data-target");
                const count = +counter.innerText;
                const increment = target / 200;
                if (count < target) {
                    counter.innerText = `${Math.ceil(count + increment)}`;
                    counter.setAttribute('data-text', count + increment);
                    setTimeout(updateCounter, timeoutVal);
                } else {
                    counter.innerText = target
                    counter.setAttribute("data-target", `${target}`)
                    counter.setAttribute('data-text', `${target}`);
                };
            };
            updateCounter();
        });
    }

    get_total_amount = () => {
        $.get(window.total_amount_url, function (data) {
            apTotalCounter(data.total_amount)
        })
    }

    bindPayoutCardListeners = (context = document) => {
        $(context).find('[data-bs-target="#activityPointsPayoutDetailsModal"][data-option-id]')
            .off('click')
            .on('click', async function () {
                window.selectedPayoutOptionId = $(this).data('option-id');
                window.selectedPayoutProvider = $(this).data('provider');
                window.selectedPayoutHistoryId = $(this).data('payout-history-id');
                window.selectedPayoutSource = $(this).data('details-source');

                if (!window.selectedPayoutOptionId && !window.selectedPayoutProvider) return;

                const modalElement = document.getElementById('activityPointsPayoutDetailsModal');
                const modalBody    = modalElement.querySelector('.modal-body');
                const modalDialog    = modalElement.querySelector('.modal-dialog');

                const params = {
                    payout_option_id: window.selectedPayoutOptionId,
                    payout_provider: window.selectedPayoutProvider,
                };

                if (window.selectedPayoutHistoryId) {
                    params.payout_history_id = window.selectedPayoutHistoryId;
                    modalBody.classList.add('h-auto');
                    modalDialog.classList.remove('modal-lg');
                    modalDialog.classList.add('modal-slg');
                } else if (window.selectedPayoutSource){
                    params.payout_details_source = window.selectedPayoutSource;
                    modalBody.classList.add('h-auto');
                    modalDialog.classList.remove('modal-slg');
                    modalDialog.classList.add('modal-lg');
                } else {
                    modalBody.classList.remove('h-auto');
                    modalDialog.classList.remove('modal-slg');
                    modalDialog.classList.add('modal-lg');
                }

                try {
                    await loadApPartial(
                        window.get_payout_details,
                        'activityPointsPayoutDetailsModalBody',
                        initPayoutSlider,
                        params
                    );
                    const modalInstance = bootstrap.Modal.getOrCreateInstance(modalElement);
                    modalInstance.show();
                } catch (err) {
                    console.error('Failed to load payout modal details:', err);
                } finally {
                    window.selectedPayoutOptionId = null;
                }
            });
    };

    loadApPartial = async (url, targetId, callback = null, params = {}, onAfterLoad = null) => {
        return new Promise((resolve) => {
            const target = document.getElementById(targetId);
            if (!target) {
                resolve();
                return;
            }

            const queryString = new URLSearchParams(params).toString();
            const fullUrl = queryString ? `${url}?${queryString}` : url;

            fetch(fullUrl, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
                .then(response => response.text())
                .then(html => {
                    setSafeHtml(target, html);

                    target.querySelectorAll('.modal').forEach(modalEl => {
                        bootstrap.Modal.getOrCreateInstance(modalEl);
                    });

                    target.querySelectorAll('[data-bs-toggle="tooltip"]').forEach(t => {
                        new bootstrap.Tooltip(t);
                    });

                    if (typeof callback === 'function') callback();
                    if (typeof onAfterLoad === 'function') onAfterLoad(target);
                    resolve();
                })
                .catch(() => resolve());
        });
    };

    function errorMessageFromXHR(xhr) {
        const data = xhr && (xhr.responseJSON || (xhr.responseText && safeParse(xhr.responseText))) || null;

        const err = data && (data.error ?? data);

        if (typeof err === 'string') return err;
        if (err && typeof err.message === 'string') return err.message;
        if (Array.isArray(err)) return err.join(', ');
        if (xhr.status === 0) return 'Network error. Please check your connection.';
        return `Error ${xhr.status || ''} ${xhr.statusText || ''}`.trim();

        function safeParse(text) {
            try { return JSON.parse(text); } catch { return null; }
        }
    }

    apPayoutSubmit = (context = document) => {
        const $thumb = $(context).find('#slider-thumb');
        const url = $thumb.data('url') || null;
        const payoutOptionId = $thumb.data('payout-option-id');
        const payoutProvider = $thumb.data('payout-provider');
        let apAmount = parseInt($thumb.data('ap-amount'), 10) || 0;
        const modalEl = document.getElementById('activityPointsPayoutDetailsModal');

        const payoutModal = bootstrap.Modal.getInstance(modalEl);

        apAmount = Math.min(apAmount, 5000);

        if (!url || !payoutOptionId) return;

        $.ajax({
            type: 'POST',
            url: url,
            data: { payout_option_id: payoutOptionId, payout_provider: payoutProvider },
            headers: {
                'X-CSRF-Token': gon.authenticity_token
            },
            success: () => {
                const bubbleAmount = (apAmount / 100);
                if (payoutModal) {
                    payoutModal.hide();
                } else {
                    console.warn('Payout instance not found. Please try again');
                }
                animateRewardBubbles(apAmount, bubbleAmount, 'spend');
                loadApPartial(window.payout_list_url, 'ap_payout_list', bindPayoutCardListeners);
            },
            error: (xhr) => {
                const msg = errorMessageFromXHR(xhr);
                $thumb.find('.button-text')
                    .text($thumb.data('error-text') || 'Error')
                    .removeClass('flash');
                $thumb.addClass('has-error');

                if (window.Noty) {
                    new window.Noty({ type: 'error', layout: 'topCenter', text: msg, closeWith: 'button', timeout: 4000 }).show();
                } else {
                    alert(msg || 'Failed to process payout. Please try again.');
                }
            }
        });
    };


    touchHandler = (event) => {
        var touch = event.changedTouches[0];

        var simulatedEvent = document.createEvent("MouseEvent");
        simulatedEvent.initMouseEvent({
                touchstart: "mousedown",
                touchmove: "mousemove",
                touchend: "mouseup"
            }[event.type], true, true, window, 1,
            touch.screenX, touch.screenY,
            touch.clientX, touch.clientY, false,
            false, false, false, 0, null);
        touch.target.dispatchEvent(simulatedEvent);
        event.preventDefault();
    }

    ["touchstart", "touchmove", "touchend", "touchcancel"].forEach(eventType => {
        document.addEventListener(eventType, function(event) {
            const modal = document.getElementById("activityPointsPayoutDetailsModal");
            if (!modal || !modal.contains(event.target)) return;
            touchHandler(event);
        }, { passive: false, capture: true });
    });

    initPayoutSlider = (context = document) => {
        const $thumb = $(context).find('#slider-thumb');
        if (!$thumb.length || $thumb.hasClass('disabled')) return;

        const $button = $thumb.find('button');
        $button.off('click').on('click', function () {
            return false;
        });

        $button.draggable({
            cancel: false,
            containment: "parent",
            axis: "x",
            stop: function () {
                const $this = $(this);
                const left = $this.position().left;
                const containerWidth = $this.parent().width();
                const threshold = containerWidth - 55;
                const submittingText = $thumb.data('submitting-text') || 'Submitting';
                if (left > threshold) {
                    $this.find('.button-text')
                        .text(`${submittingText}...`)
                        .addClass('animated flash infinite slower');
                    $this.css({ left: "auto", right: 0 })
                        .addClass("submitted")
                        .draggable("disable");
                    apPayoutSubmit();
                } else {
                    $this.css({ left: 0 });
                }
            }
        });
    }

    animateRewardBubbles = (earnedAmount = null, bubbleCount = 7, claimType = 'get') => {
        const target = document.querySelector('.ap_coins_value');
        if (!target) return;

        const targetRect = target.getBoundingClientRect();
        const centerX = window.innerWidth / 2;
        const centerY = window.innerHeight / 2;

        const container = document.body;
        const sizes = ['lg', 'xl', 'xxl', 'xxxl'];

        // === Add earnedAmount popup (if provided) ===
        if (earnedAmount) {
            const amountElColorClass = claimType === "get" ? 'get' : 'spend';
            const amountEl = document.createElement('div');
            amountEl.className = `earned-amount-popup ${amountElColorClass}`;
            amountEl.textContent = `${claimType === "get" ? '+ ' : '- '} ${earnedAmount}`;

            amountEl.style.left = `${centerX}px`;
            amountEl.style.top = `${centerY}px`;
            amountEl.style.opacity = '0';
            amountEl.style.transition = 'opacity 0.3s ease-out, transform 0.3s ease-out';

            container.appendChild(amountEl);
            void amountEl.offsetWidth;

            amountEl.style.opacity = '1';
            amountEl.style.transform = 'translate(-40%, -60%)';

            setTimeout(() => {
                amountEl.style.opacity = '0';
                amountEl.style.transform = 'translate(-50%, -70%)';
                setTimeout(() => {
                    /*amountEl.remove()*/
                }, 300);
            }, 600);
        }

        for (let i = 0; i < bubbleCount; i++) {
            const bubble = document.createElement('div');
            const size = sizes[Math.floor(Math.random() * sizes.length)];
            bubble.className = `bubble-icon main-bubble claim-animation ${size}`;

            const offsetX = (Math.random() - 0.5) * 100;
            const offsetY = (Math.random() - 0.5) * 100;

            bubble.style.left = `${centerX + offsetX}px`;
            bubble.style.top = `${centerY + offsetY}px`;

            container.appendChild(bubble);
            void bubble.offsetWidth;

            const endX = targetRect.left - centerX + targetRect.width / 2;
            const endY = targetRect.top - centerY + targetRect.height / 2;

            bubble.style.transform = `translate(${endX}px, ${endY}px) scale(0.4)`;
            bubble.style.opacity = '0';

            setTimeout(() => bubble.remove(), 1200);
        }
        get_total_amount();
    }

    setBadgeClasses = (level, isGhost, progress, icon, tabsNav= false) => {
        const baseLevel = level || 'mission';
        const badgeClass = icon === "gift" ? 'gift' : baseLevel === "mission" ? 'base' : isGhost ? `ghost_${baseLevel}` : baseLevel;
        const gradientClass = isGhost && baseLevel !== "mission" ? 'ghost_gradient' : icon === "gift" ? 'gift-gradient' : `${baseLevel}-gradient`;
        const animClass = progress === 100 || !tabsNav ? `animated ${!tabsNav ? 'flipInY' : 'flip with-delay'}` : '';
        const showModal = tabsNav ? 'show' : '';
        const badgeShadowClass = !isGhost && baseLevel !== "mission" && tabsNav  ? 'show-shadow' : '';
        const badgeFloatingAnimation = !isGhost && baseLevel !== "mission" ? 'float-infinite' : '';

        $modal.find('.badge.size-xl').removeClass('animated');
        $modal.removeClass(function (i, c) {
            return (c.match(/(?:^|\s)(ghost_\w+|\iron|\bbronze\b|\bsilver\b|\bgold\b|\baurora\b|\bmission\b|\bbase\b|\bgift\b)/g) || []).join(' ');
        }).addClass(`${showModal} ${badgeClass}`);
        $modal.find('.badge.size-xl')
            .attr('class', `badge size-xl ${badgeClass} with-glow-effect ${animClass} ${badgeShadowClass}`);
        $modal.find('.badge i.badge-ico')
            .attr('class', `badge-ico ${gradientClass} ico-${icon}`);

        if (badgeFloatingAnimation !== '') {
            $modal.find('.badge.flip.with-delay').one("animationend webkitAnimationEnd oAnimationEnd MSAnimationEnd", function() {
                $modal.find('.badge.flip.with-delay').removeClass('flip');
                $modal.find('.badge.with-delay').addClass(badgeFloatingAnimation);
            });
        }
    }

    updateModalDisplay = (selected, variants = [], isRewardDetailsView = false) => {
        const isGhost = selected.progress !== 100;
        const level = selected.level || 'mission';
        const $claimBtn = $modal.find('.btn-claim-reward');

        setBadgeClasses(level, isGhost, selected.progress, selected.icon, !isRewardDetailsView);

        // Message and Reward
        if (!isRewardDetailsView) {
            $modal.removeClass('for-rewards');
            $modal.find('.progress-bar').css('width', `${selected.progress}%`);
            $modal.find('.progress')
                .attr('class', `progress ${level}`)
                .attr('aria-valuenow', selected.progress);

            const descriptions = Array.isArray(selected.descriptions)
                ? selected.descriptions
                : [selected.descriptions];

            const targets = Array.isArray(selected.targets)
                ? selected.targets
                : [selected.targets];

            const currents = Array.isArray(selected.currents)
                ? selected.currents
                : [selected.currents];

            const alertTitle = Array.isArray(selected.currents) && selected.currents.length > 1
                ? $modal.find('.message-title').data('msg-title-plural')
                : $modal.find('.message-title').data('msg-title-sing');

            $modal.find('.message-title').text(alertTitle);

            const $baseAlert = $modal.find('.message-alert-content').first();
            $baseAlert.siblings('.message-alert-content').remove();

            descriptions.forEach((description, index) => {
                const $alert =
                    index === 0
                        ? $baseAlert
                        : $baseAlert.clone().insertAfter($baseAlert);
                $alert.find('.message-text').text(description || '');
                $alert
                    .find('.message-progress')
                    .text(`${currents[index] || 0} of ${targets[index] || 0}`)
                    .show();

                $alert.find('.progress').show();
                $alert.show();
            });
        } else {
            $modal.addClass('for-rewards');
            $modal.find('.progress').hide();

            const $messageAlert = $modal.find('.message-alert-content').first();
            $messageAlert.siblings('.message-alert').remove();

            $messageAlert.find('.message-progress').hide();
            $messageAlert.find('.message-text').text(
                Array.isArray(selected.descriptions)
                    ? selected.descriptions
                    : [selected.descriptions]
            );

            $modal.find('#reward-claim-date').text(`${selected.created_at}`);
            $messageAlert.show();
        }

        setAmountPlaceholder(selected.reward, $modal[0])

        // Reward button state
        if ((isRewardDetailsView || (selected.progress === 100 && !isRewardDetailsView)) && !selected.claimed) {
            $claimBtn.removeClass('disabled in-progress')
                .attr('data-reward-to-claim', `${selected.reward_id}`)
                .attr('data-url', `${window.ap_claim}`);
            $claimBtn.off('click').on('click', function (event) {
                handleClaimButtonClick.call(this, event, selected.reward_id);
            });
            $claimBtn.find('.text').text(window.reward_button_ready_to_claim_state_title);
        } else if (selected.progress === 100 && selected.claimed) {
            $claimBtn.removeClass('in-progress')
                .addClass('disabled')
                .attr('data-reward-to-claim', '')
                .attr('data-url', '')
                .off('click');
            $claimBtn.find('.text').text(window.reward_button_claimed_state_title);
        } else {
            $claimBtn.removeClass('disabled')
                .addClass('in-progress')
                .attr('data-reward-to-claim', '')
                .attr('data-url', '')
                .off('click');
        }

        // Variants
        const $variantsWrapper = $modal.find('.variants-tab-nav').empty();
        if (!isRewardDetailsView && variants.length) {
            $variantsWrapper.show();
            variants.forEach((variant) => {
                const isSelected = variant.variant_id === selected.variant_id;
                const isGhost = variant.progress !== 100;
                const badgeLevelClass = isGhost ? `ghost_${variant.level}` : variant.level;
                const $div = $('<div></div>')
                    .addClass(`badge-placeholder hoverable p-2 ${isSelected ? 'bg-light rounded-4' : ''}`)
                    .attr('data-variant-id', variant.variant_id)
                    .attr('data-source-type', "badge");

                $div[0].appendChild(buildVariantBadgeNode({ levelClass: badgeLevelClass, icon: variant.icon }))
                $variantsWrapper.append($div);
            });

            $modal.find('.badge-placeholder').off('click').on('click', function (e) {
                e.stopPropagation();
                const isRewardDetailsView = $(this).data('source-type') === "reward";
                const variantId = $(this).data('variant-id');
                const next = variants.find(v => v.variant_id === variantId);
                if (next) updateModalDisplay(next, variants, isRewardDetailsView);
            });
        } else {
            $variantsWrapper.hide();
        }
    };

    claim_ap = (url, rewardId, $button) => {
        $.ajax({
            type: 'POST',
            url: url,
            data: { reward_id: rewardId },
            success: async (response) => {
                try {
                    animateRewardBubbles(response.reward_amount, Math.min(response.reward_amount, 500)/10);
                    $button.data('reward-to-claim', '');
                    window.bsModal.hide();
                    $(`.card[data-reward-to-claim=${rewardId}], .card[data-badge-id=${rewardId}]`).hideWithAnimation();
                } finally {
                    await loadApPartial(window.user_rewards_list_url, 'ap_rewards_user_rewards_list', null, {}, updateRewardsCountBadge);
                }
            },
            error: function(xhr) {
                alert('Failed to process payout. Please try again.');
                console.error(xhr.responseText);
            }
        });
    };

    handleClaimButtonClick = function (event, directId = null) {
        event.preventDefault();
        const $claimRewardButton = $(this);
        const url = $claimRewardButton.data('url');
        const rewardId = directId ? directId : $claimRewardButton.data('reward-to-claim');

        if (url && rewardId) {
            claim_ap(url, rewardId, $claimRewardButton);
        }
    };

    $.fn.hideWithAnimation = function(animation = 'fadeOutUp', duration = 1000) {
        return this.each(function() {
            const $el = $(this);
            animateCardsInOut(this, 'out', false, animation);
            $el.one('animationend webkitAnimationEnd oAnimationEnd MSAnimationEnd', function() {
                $el.hide();
            });
        });
    };

    showApHistory = () => {
        $('#ap_rewards_history_list_modal').show();
        bindPayoutCardListeners();
    };

    animateCardsInOut = (className = '.custom-anim', direction = 'in', withDelay = true, animationName = null) => {
        $(`${className}`).each( function () {
            const delayClass = withDelay ? 'with-delay' : '';
            if (animationName) {
                $(this).addClass(`${animationName} ${delayClass}`);
            } else if ($(this).attr('id')==="daily-mission-countdown") {
                $(this).addClass(`fadeInDown ${delayClass}`);
            } else {
                switch (direction) {
                    case 'in':
                        $(this).addClass(`fadeInUp ${delayClass}`);
                        break;
                    case 'out':
                        $(this).addClass(`fadeOutUp ${delayClass}`);
                        break;
                }
            }
        });

    }

    $(document).on('show.bs.modal', '#activityPointsHistory', function () {
        loadApPartial(window.get_history_modal_content, 'ap-history-list')
    });

    $(document).on('click', '#ap-history-list .pagination a', function (e) {
        e.preventDefault();
        const url = this.href;
        loadApPartial(url, 'ap-history-list');
    });

    $modal.on('hidden.bs.modal', function () {
        $modal.find('.progress-bar').css('width', '0');
        $modal.find('.badge.size-xl').attr('class', 'badge size-xl with-glow-effect');
        $modal.find('.badge i.badge-ico').attr('class', 'badge-ico ico-');
        $modal.find('.message-text').text('\u00A0');
        $modal.find('.message-progress').text('- of -');
        setAmountPlaceholder('0000', $modal[0])
        $modal.find('.variants-tab-nav').empty().show();
    });

    if ($menuApCount.length > 0) {
        updateRewardsCountBadge();
    }


    const $nicknameModal = $('#activityPointsLeaderboard');

    $nicknameModal.off('submit', 'form').on('submit', 'form', async function (e) {
        e.preventDefault();

        const $form = $(this);
        const nickname = $form.find('input').val()?.trim();

        if (!nickname) {
            alert('Nickname cannot be empty.');
            return;
        }
        try {
            const response = await $.ajax({
                type: 'POST',
                url: '/en/workplace/activity_points/update_nickname',
                data: { nickname },
                headers: {
                    'X-CSRF-Token': gon.authenticity_token
                }
            });
            if (response.success) {
                await loadApPartial(window.get_leader_boards, 'ap_leaderboards_container');
                const modalInstance = bootstrap.Modal.getInstance($nicknameModal[0]);
                if (modalInstance) {
                    $nicknameModal.one('hidden.bs.modal', () => {
                        $nicknameModal.remove();
                    });
                    modalInstance.hide();
                }
            } else {
                alert(response.error || 'Failed to update nickname.');
            }
        } catch (err) {
            console.error('[AP] Nickname update error');
        }
    });

    isSafariBrowser();
});

